import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    loginWithGoogle(sessionId)
      .then(() => {
        // Clear hash and navigate to account
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/account', { replace: true });
      })
      .catch(() => {
        navigate('/login');
      });
  }, [loginWithGoogle, navigate]);

  return null; // No UI · silent processing
}
